module.exports = __webpack_public_path__ + "img/o.9116a620.jpg";